package com.anjuros.website.templates.template8.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosBackgroundImage
import com.anjuros.website.components.shared.AnjurosCopyright
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.FacebookSquareIcon

import com.anjuros.website.templates.template8.modules.Template8Section
import com.anjuros.website.templates.template8.styles.Template8ButtonStyle
import com.anjuros.website.templates.template8.styles.Template8FooterCopyrightTextStyle
import com.anjuros.website.templates.template8.styles.Template8FooterMarginStyle
import com.anjuros.website.templates.template8.styles.Template8FooterTextStyle
import com.anjuros.website.templates.template8.styles.Template8NavigationItemStyle
import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.util.Template8CompanyDetails
import com.anjuros.website.templates.template8.util.Template8Constants
import com.anjuros.website.templates.template8.util.Template8Constants.CLIENTS_FB_LINK
import com.anjuros.website.templates.template8.util.Template8Constants.CLIENTS_MAP
import com.anjuros.website.templates.template8.util.Template8Constants.FONT_FAMILY
import com.anjuros.website.templates.template8.util.Template8Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template8FooterSection(
    clickable: Boolean = true
) {


    Box(
        modifier = Modifier
            .fillMaxWidth(),
        contentAlignment = Alignment.Center
    ) {

        AnjurosBackgroundImage(
            modifier = Modifier.fillMaxWidth()
                .fillMaxHeight()
                .displayIfAtLeast(Breakpoint.LG)
                .align(Alignment.Center)
                .objectFit(ObjectFit.Cover),
            src = Template8Res.Image.template8_header_background,
            alt = "Pub menu"
        )
        AnjurosBackgroundImage(
            modifier = Modifier.fillMaxWidth()
                .displayUntil(Breakpoint.LG)
                .align(Alignment.Center)
                .height(500.px)
                .objectFit(ObjectFit.Cover),
            src = Template8Res.Image.template8_background_small,
            alt = "Pub menu"
        )
        Template8FooterContent(
            clickable = clickable
        )
    }
}

@Composable
private fun Template8FooterContent(
    clickable: Boolean = true
) {

    SimpleGrid(
        numColumns = numColumns(base = 1, md = 1, lg = 3),
        modifier = Modifier.fillMaxSize()
            .padding(topBottom = 10.px)
    ) {

        Template8FooterLogo()

        Template8FooterContact()
        Template8FooterMenu(
            clickable = clickable
        )
    }
}

@Composable
fun Template8FooterMenu( clickable: Boolean = true) {
    Box(modifier = Modifier.fillMaxHeight()) {
        Column(
            modifier = Modifier.align(Alignment.Center),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Template8Section.entries.toTypedArray().forEach { section ->
                Link(
                    modifier = Modifier
                        .padding(
                            right = 0.px,
                            bottom = if (section.ordinal < Template8Section.entries.size - 1) 20.px else 0.px
                        )
                        .textDecorationLine(TextDecorationLine.None),
                    path = if(clickable) {section.path} else ""
                ) {
                    P(
                        attrs = Template8NavigationItemStyle.toModifier()

                            .margin(topBottom = 0.px)
                            .fontFamily(FONT_FAMILY)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Normal)
                            .toAttrs()
                    ) {
                        Text(LocalText(section.title))
                    }
                }

            }
        }
    }

}

@Composable
fun Template8FooterLogo() {

    Box(
        modifier = Template8FooterMarginStyle.toModifier().fillMaxWidth()
    ) {


        Box(
            modifier = Modifier
                .align(Alignment.Center)
                .margin(bottom = 20.px)
        ) {

            Row(
                horizontalArrangement = Arrangement.spacedBy(20.px),
                verticalAlignment = Alignment.CenterVertically
            ) {

                CompanyDetails(
                    modifier = Modifier
                )
            }
        }

        Box(modifier = Modifier.displayIfAtLeast(Breakpoint.MD).align(Alignment.BottomCenter)) {
            AnjurosCopyright(Modifier.align(Alignment.BottomCenter))
        }
    }

}

@Composable
fun Template8FooterContact(){

    Box(modifier = Modifier.fillMaxHeight().fillMaxWidth()) {
        Column(
            modifier = Modifier.align(Alignment.Center),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Template8BookATable()
            Link(
                modifier = Template8FooterTextStyle.toModifier()
                    .fontFamily(FONT_FAMILY)
                    .fontWeight(FontWeight.Normal)
                    .color(Template8Theme.Primary.rgb)
                    .display(DisplayStyle.Flex)
                    .justifyContent(JustifyContent.Start)
                    .textAlign(TextAlign.Start)
                    .alignItems(AlignItems.Center)
                    .fontWeight(FontWeight.Bold)
                    .textDecorationLine(TextDecorationLine.None),
                path = CLIENTS_FB_LINK
            ) {
                FacebookSquareIcon(modifier = Modifier
                    .margin(right=4.px, bottom = 2.px)
                    .color(Template8Theme.Primary.rgb),
                    size = 24)
                AnjurosText(Template8CompanyDetails.CLIENTS_FACEBOOK_INFO)
            }
            Box(modifier = Modifier.displayUntil(Breakpoint.MD).margin(top=5.px)) {
                Column(modifier = Modifier
                    .align(Alignment.BottomCenter),
                    verticalArrangement = Arrangement.spacedBy(10.px),
                    horizontalAlignment = Alignment.CenterHorizontally) {

                    AnjurosCopyright(
                        Template8FooterCopyrightTextStyle.toModifier()
                    )
                }
            }
        }

    }
}

@Composable
fun Template8BookATable(){
    Box(
        modifier = Template8ButtonStyle.toModifier()
            .margin(bottom = 20.px)
            .backgroundColor(Template8Theme.Primary.rgb)
            .borderRadius(5.px)
            .boxShadow(
                2.px, 2.px, 8.0.px, 2.0.px, color = Template8Theme.DarkGrey.rgb, false
            )
    ) {
        Link(
            path = "tel:${Template8Constants.CLIENTS_PHONE}",
            modifier = Modifier
                .textDecorationLine(TextDecorationLine.None)
                .align(Alignment.Center),
            openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB

        ) {
            P(
                attrs = Modifier
                    .margin(5.px)
                    .align(Alignment.Center)
                    .fontFamily(FONT_FAMILY)
                    .color(Colors.White)
                    .fontSize(18.px)
                    .fontWeight(FontWeight.Normal)
                    .toAttrs()
            ) {
                AnjurosText(Template8CompanyDetails.CLIENTS_PHONE_INFO)
            }
        }
    }
}


@Composable
fun CompanyDetails(modifier: Modifier) {
    Link(
        path = CLIENTS_MAP,
        modifier = Modifier
            .textDecorationLine(TextDecorationLine.None),
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB

    ) {
        Column(modifier = modifier) {
            P(
                attrs = Modifier

                    .margin(topBottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(20.px)
                    .color(Template8Theme.Primary.rgb)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                AnjurosText(Template8CompanyDetails.CLIENTS_NAME_INFO)
            }
            P(
                attrs = Modifier

                    .margin(topBottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(14.px)
                    .color(Template8Theme.Primary.rgb)
                    .fontWeight(FontWeight.Normal)
                    .toAttrs()
            ) {
                AnjurosText(Template8CompanyDetails.CLIENTS_COMPANY_NUMBER_INFO)
            }
            P(
                attrs = Modifier

                    .margin(topBottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(14.px)
                    .color(Template8Theme.Primary.rgb)
                    .fontWeight(FontWeight.Normal)
                    .toAttrs()
            ) {
                AnjurosText(Template8CompanyDetails.CLIENTS_COMPANY_ADDRESS1_INFO)
            }
            P(
                attrs = Modifier

                    .margin(topBottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(14.px)
                    .color(Template8Theme.Primary.rgb)
                    .fontWeight(FontWeight.Normal)
                    .toAttrs()
            ) {
                AnjurosText(Template8CompanyDetails.CLIENTS_COMPANY_ADDRESS2_INFO)
            }
        }
    }
}